"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tableRowVariant = tableRowVariant;
exports.default = void 0;

var _color = _interopRequireDefault(require("@bootstrap-styled/color"));

var _hover = require("./hover");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Tables
function tableRowVariant(state, background) {
  var hoverBackground = (0, _color.default)(background).darken(0.05).toString();
  return "\n  /* Exact selectors below required to override '.table-striped' and prevent */\n  /* inheritance to nested tables. */\n  & .table-".concat(state, " {\n    &,\n    > th,\n    > td {\n      background-color: ").concat(background, ";\n    }\n  }\n\n  /* Hover states for '.table-hover' */\n  /* Note: this is not available for cells or rows within 'thead' or 'tfoot'. */\n  &.table-hover {\n\n    .table-").concat(state, " {\n      ").concat((0, _hover.hover)("\n        background-color: ".concat(hoverBackground, ";\n\n        > td,\n        > th {\n          background-color: ").concat(hoverBackground, ";\n        }\n      ")), "\n    }\n  }\n  ");
}

var _default = {
  tableRowVariant: tableRowVariant
};
exports.default = _default;